import React from 'react'
import PropTypes from 'prop-types'

import { FormWrapper, Input } from 'components';
import { Form, Modal, Header, TransitionablePortal } from 'semantic-ui-react'

import { API } from 'services';

class ModalCreateSensor extends React.Component {

  constructor(props) {
    super(props);

    this.handleSubmit = this.handleSubmit.bind(this);

    this.state = {
      actions: {
        submit: {
          name: "Valider",
          callback: this.handleSubmit
        },
        cancel: {
          name: "Annuler",
          callback: this.props.onClose
        }
      }
    };
  }

  handleSubmit(data, onSucess, onError) {

    //Sanitize MAC address
    data.mac_address = data.mac_address.replaceAll(/(:|-|\.)/g, '');

    API.post('/sensors', data)
      .then((response) => {
        this.props.onClose(response.data);
      })
      .catch((error) => {
        onError(API.violations(error));
      });
  }

  render() {

    return (
      <TransitionablePortal open transition={{ animation: "fade down", duration: 250 }}>
        <Modal open size='small'>
          <Header icon="add" content="Nouveau capteur" />
          <Modal.Content>

            <FormWrapper actions={this.state.actions}>

              {/* Name */}
              <Form.Field>
                <label htmlFor="inputMacAddress" className="required">Adresse mac</label>
                <Input id="inputMacAddress" name="mac_address" placeholder="##:##:##:##:##:##" />
              </Form.Field>

            </FormWrapper>

          </Modal.Content>
        </Modal>
      </TransitionablePortal>
    );
  }
}

ModalCreateSensor.propTypes = {
  onClose: PropTypes.func.isRequired
};

export default ModalCreateSensor;
